export const getEnvironmentId = (): string => {
    let environmentID = 'dev';

    const h = document.location.host;

    if (h === 'insights.hotjar.com' || h === 'surveys.hotjar.com') {
        environmentID = 'live';
    } else {
        const result = h.match(/^(insights|surveys)-(.+)\.review\.eks\.hotjar\.com$/);
        if (result) {
            environmentID = result[2];
        } else if (h === 'insights-staging.hotjar.com' || h === 'surveys-staging.hotjar.com') {
            environmentID = 'staging';
        }
    }

    return environmentID;
};
